import React from 'react';
// import Restaurant from './component/Basics/Restaurant';
//import UseState from './component/Hooks/useState';
// import UseEffect from './component/Hooks/useEffect';
// import UseReducer from './component/Hooks/useReducer';
//import ToDo from './component/ToDoList/ToDo';
import Temp from './component/Weather/Temp';
const App = () => {
   return <Temp />;
  
};

export default App;